import { render, staticRenderFns } from "./XtendsTable.vue?vue&type=template&id=33114581&"
import script from "./XtendsTable.vue?vue&type=script&lang=js&"
export * from "./XtendsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports